(function() {
	'use strict';
	angular.module('app.setup')
		.controller('projectCategoriesDeleteForm', projectCategoriesDeleteForm);

	projectCategoriesDeleteForm.$inject = ['$scope'];
	function projectCategoriesDeleteForm($scope) {
		var vm = this;
		// view model functions
		vm.projectCategory = $scope.projectCategory;
		vm.categories = $scope.categories;
		vm.deleteCallBack = $scope.deleteCallBack;
		vm.replaceCallBack = $scope.replaceCallBack;
		vm.hasProjects = hasProjects();
		vm.deleteAction = true;
		vm.isSaveButtonDisabled = false;
		vm.action = $scope.action;
		vm.close = close;
		vm.remove = remove;

		function remove() {
			vm.isSaveButtonDisabled = true;
			if (vm.deleteAction) {
				vm.deleteCallBack(vm.projectCategory.ndx).then(function() {
					$scope.result();
					vm.isSaveButtonDisabled = false;
				});
			} else {
				vm.replaceCallBack(vm.projectCategory.ndx, vm.newCategoryNdx).then(function() {
					$scope.result();
					vm.isSaveButtonDisabled = false;
				});
			}
		}

		function hasProjects() {
			return vm.projectCategory.noOfActiveLeanProjects
				|| vm.projectCategory.noOfActiveSupplierProjects
				|| vm.projectCategory.noOfArchiveLeanProjects
				|| vm.projectCategory.noOfArchiveSupplierProjects
				|| vm.projectCategory.noOfTemplates;
		}
		
		function close() {
			$scope.result();
		}
	}
})();
